<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-sort
    data-url="admin/nsr/"
    data-key="items"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="nsr-item-list"
  >
    <template v-slot:item.value="{ item }">
      {{ getRate(item) }}
    </template>
    <template v-slot:item.created_by="{ item }">
      {{ item.created_by ? item.created_by.name : "-" }}
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn text color="primary" @click="editItemRbu(item)"> RBU </v-btn>
        <v-btn text color="primary" @click="editItem(item)"> EDIT </v-btn>
        <v-btn text color="primary" @click="deleteItem(item)"> DELETE </v-btn>
      </div>
    </template>
  </RemotePaginatedList>
</template>
<script>
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {
  onMounted,
  ref,
  watch,
} from "@vue/composition-api/dist/vue-composition-api";
import EditNsrItemDialog from "@/components/nsr/EditNsrItemDialog";
import { ACTION_TYPES } from "@/store/types";
import { computed } from "@vue/composition-api";
import { SPECIAL_PERMISSIONS } from "@/constants";

export default {
  name: "NsrItemList",
  components: { RemotePaginatedList },
  props: {
    refreshTrigger: Boolean,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(true);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([
      { text: root.$t("nsr_item.item_no"), value: "item_no", contains: true },
      {
        text: root.$t("nsr_item.contract_no"),
        value: "contract_no",
        contains: true,
      },
      {
        text: root.$t("nsr_item.contract_year"),
        value: "contract_year",
        options: ["A", "B", "C", "D", "E"],
      },
      {
        text: root.$t("nsr_item.work_order_no"),
        value: "work_order_no",
        contains: true,
      },
      {
        text: root.$t("nsr_item.action_description"),
        value: "action_description",
        contains: true,
      },
      {
        text: root.$t("nsr_item.unit_id"),
        value: "unit_id",
        options: ["A", "B", "C", "D", "E"],
      },
      { text: root.$t("nsr_item.unit"), value: "unit", contains: true },
    ]);

    // Data Table
    const headers = ref([
      { text: root.$t("nsr_item.item_no"), value: "item_no" },
      {
        text: root.$t("nsr_item.action_description"),
        value: "action_description",
      },
      { text: root.$t("nsr_item.work_order_no"), value: "work_order_no" },
      { text: root.$t("nsr_item.unit_id"), value: "unit_id" },
      { text: root.$t("nsr_item.unit"), value: "unit" },
      { text: root.$t("nsr_item.value"), value: "value" },
      { text: root.$t("nsr_item.contract_no"), value: "contract_no" },
      { text: "Creator", value: "created_by" },
      { text: "", value: "actions", sortable: false, width: "50px" },
    ]);
    const innerRefreshTrigger = ref(false);

    const editItemRbu = async function (item) {
      root.$router.push({
        name: "nsr-item-rbu",
        params: { nsrItemId: item.id },
      });
    };

    const editItem = async function (item) {
      const needRefresh = await root.$dialog.showAndWait(EditNsrItemDialog, {
        nsrItem: item,
        persistent: true,
        showClose: false,
        width: "640px",
      });

      if (needRefresh) {
        refresh();
      }
    };
    const deleteItem = async function (item) {
      if (
        await root.$dialog.confirm({
          text: root.$t("nsr_item.delete_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/nsr/delete/",
          params: { item_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };

    const getRate = (item) => {
      if (!item.value) return "$0";
      if (!item.rounding) return "$" + item.value;
      if (!item.saved) return "$" + item.value;

      try {
        return root.$parseCurrency(item.value, item.rounding);
      } catch (e) {
        console.log(e);
        return "$" + item.value || "$0";
      }
    };

    return {
      filterOptions,
      headers,
      innerRefreshTrigger,
      editItem,
      deleteItem,
      editItemRbu,
      getRate,
    };
  },
};
</script>
